<template>
<!--  ==============================  MODAL_SECTION START ============================== -->
  <b-modal
    id="modal-units"
    :title="editMode == true ?  $t('edition') : $t('add__units')"
    cancel-variant="outline-secondary"
    :ok-title="editMode == true ? $t('general.edit') : $t('general.add')"
    ok-variant="success"
    :cancel-title="$t('general.close')"
    centered
    no-close-on-backdrop
    @cancel="onCancel"
    @close="onCancel"
    @show="showModal"
    @ok="onSubmitUnits"
  >
    <b-form>
      <validation-observer ref="unitsValidations">
        <b-form-group :label="$t('units.cut')" for="unit">
          <validation-provider
            #default="{ errors }"
            :name="$t('units.cut')"
            rules="required"
          >
            <b-form-input
              :label="$t('units.mean')"
              v-model="units.short_title"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group :label="$t('units.mean')" for="units">
          <validation-provider
            #default="{ errors }"
            :name="$t('units.mean')"
            rules="required"
          >
            <b-form-input id="units" v-model="units.title" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </validation-observer>
    </b-form>
  </b-modal>
<!--  ==============================  MODAL_SECTION END ============================== -->
</template>

<script>
import { BModal, VBModal, BForm, BFormInput, BFormGroup } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";

export default {
  name: "AddEditModal",
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    editUnits: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {




      // ===============  PRIMARY_DATA_SECTION START ===============
      units: {
        short_title: "",
        title: "",
      },
      editMode: false,
      // ===============  PRIMARY_DATA_SECTION END ===============




    };
  },
  methods: {
    ...mapActions("characterUnits", [
      "CREATE_UNITS",
      "UPDATE_UNITS",
    ]),





    // ===============  ON_SHOW_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode
      this.units = {
        short_title: "",
        title: "",
      };
      if (!this.editUnits) {
        return;
      }

      if (typeof this.editUnits === "object" && this.editUnits !== null) {
        this.units.short_title = this.editUnits.short_title;
        this.units.title = this.editUnits.title;
      }
    },
    // ===============  ON_SHOW_SECTION END ===============



    onCancel(){
      this.$route.params.editMode = false
    },
    onClose(){
      this.$route.params.editMode = false
    },



    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitUnits(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.unitsValidations.validate().then((success) => {
        if (!success) {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }

        try {
          if (this.editUnits.id) {
            this.UPDATE_UNITS({
              id: this.editUnits.id,
              data: this.units,
            }).then(async () => {
              await this.$parent.refresh()
            });
          } else {
            this.CREATE_UNITS(this.units).then(async () => {
              await this.$parent.refresh()
            });
          }
          this.$nextTick(() => {
            this.$route.params.editMode = false
            this.$bvModal.hide("modal-units");
          });

          this.units = {
            short_title: "",
            title: "",
          };

          this.$_okToast();
        } catch (err) {
          this.$_errToast(err);
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============





  },
};
</script>

<style scoped lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
